/** Spinner shown on the report "Get" button while purchase is in progress. */
export function ReportGetButton({ isLoading }: { isLoading: boolean }) {
  if (isLoading) {
    return (
      <span className="flex size-9 min-w-9 items-center justify-center rounded-full bg-green/20">
        <span className="size-5 animate-spin rounded-full border-2 border-green/30 border-t-green" />
      </span>
    )
  }

  return (
    <span className="flex h-9 items-center justify-center rounded-full bg-green/20 px-6 font-body text-base font-semibold text-green">
      Get
    </span>
  )
}

/** Compact spinner for the personalized reports list row. */
export function ReportGetButtonCompact({ isLoading }: { isLoading: boolean }) {
  if (isLoading) {
    return (
      <span className="flex size-8 min-w-8 items-center justify-center rounded-full bg-green/20">
        <span className="size-4 animate-spin rounded-full border-2 border-green/30 border-t-green" />
      </span>
    )
  }

  return (
    <span className="flex h-8 items-center justify-center rounded-full bg-green/20 px-4 font-body text-sm font-semibold text-green">
      Get
    </span>
  )
}
